var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 29.2 29.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#723e82",
    d: "M0 20.2 14.6 5.6l14.6 14.6-3.4 3.4-11.2-11.2L3.4 23.6 0 20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpPurple);
export default __webpack_public_path__ + "static/media/arrowUpPurple.0f16fae7e728fab22eddbe8b14b29853.svg";
export { ForwardRef as ReactComponent };